export default "__VITE_ASSET__vr2TcLcw__"